export default "/images/vendor/flag-icon-css/flags/4x3/np.svg?3b3316c4ce37e2097103a5dedeb4111a";